



















import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivitySessionTable from '@activities/components/tables/activity-session-table/activity-session-table.vue';
import { Activity } from '@activities/interfaces/activity';

@Component({
  name: 'bpc-club-activity-calendar',
  components: {
    'bpc-activity-session-table': ActivitySessionTable,
  },
})
export default class ClubActivityCalendar extends Vue {
  formConfigName: string = 'create-for-clubs';
  editFormConfigName: string = 'edit-from-management-for-clubs';
  filterConfigName: string = 'default-for-club';
  extendedFilterConfig: string = 'extended-for-club';
  activity: Activity = null;
  onEditFromCalendar($event) {
    console.log($event);
    if ($event?.activity_type === 'competition') {
      this.activity = { ...$event };
      this.editFormConfigName = 'edit-competition-for-clubs';
    } else {
      this.activity = null;
      this.editFormConfigName = 'edit-from-management-for-clubs';
    }
  }
  onEditFromTable($event) {
    console.log($event);
    if ($event === 'competition') {
      this.activity = { ...$event };
      this.editFormConfigName = 'edit-competition-for-clubs';
    } else {
      this.activity = null;
      this.editFormConfigName = 'edit-from-management-for-clubs';
    }
  }
  onViewChanged($event) {
    this.activity = null;
  }
  onCreateFromCalendar($event) {
    this.activity = null;
  }
  /* Lifecycle hooks */
  // created() { }
  mounted() {
    this.setSessionFormConfig();
  }
  // updated () { }
  // destroyed () { }

  // METHODS
  setSessionFormConfig() {
    //NOTE: if the user only has own permission, the form config is different.
    if (
      !this.$authorizationService.hasPermission('manage_activity_sessions') &&
      this.$authorizationService.hasPermission('manage_own_activity_sessions')
    ) {
      this.formConfigName = 'create-for-clubs-hidden-responsibles';
    }
  }
}
